import Container = Phaser.GameObjects.Container;
import Scene = Phaser.Scene;
import Sprite = Phaser.GameObjects.Sprite;
import SpriteUtils from "@/utils/sprite-utils";

export default class SpriteContainer extends Container {

    private mainImage: Sprite | undefined;

    constructor(scene: Scene, x: number, y: number, atlasKey: string, imageKey: string, callback: () => unknown) {
        super(scene);

        this.x = x;
        this.y = y;

        this.mainImage = SpriteUtils.addSprite(this.scene, 0, -2, atlasKey, imageKey, 0.85).setInteractive().on('pointerdown', () => {
            if (callback != null) {
                callback();
            }
        });

        this.add([this.mainImage]);
    }

}
